import theme from "../../../Layout/utils/theme";

export const CATEGORIES = [
  {
    label: "Info (e.g. new feature)",
    value: "info",
    color: theme.palette.info.main,
  },
  {
    label: "Warning (e.g. upcoming maintenance)",
    value: "warning",
    color: theme.palette.warning.main,
  },
  {
    label: "Critical (e.g. security issue)",
    value: "critical",
    color: theme.palette.error.main,
  },
  {
    label: "Success (e.g. migration completed)",
    value: "success",
    color: theme.palette.success.main,
  },
];

export const VARIANTS = ["Standard", "Filled", "Outlined"];
